<template>
    <div class="serviceP">
        <h2>服务套餐</h2>
        <div class="wrap"></div>
        <p>彩虹律师根据您的需求不同，提供了三个版本，请选择适用您的版本</p>
        <el-button type="primary" @click="Tocontact">立即体验</el-button>
    </div>
</template>

<script>
    export default {
        name: "serviceP",
        data(){
            return{
                isShow:true
            }
        },
        methods:{
            Tocontact(){
                this.isShow = !this.isShow;
                this.$emit('childByBtn', this.isShow);
                // console.log("111");
                this.isShow = !this.isShow;
            }
        }
    }
</script>

<style lang="less" scoped>
.serviceP{
    width: 100%;
    height: 1630px;
    background: rgb(248,248,248);
    text-align: center;
    h2{
        font-size: 30px;
        color: rgb(43,43,43);
        text-align: center;
        padding-bottom: 40px;
        padding-top: 80px;
    }
    .wrap{
        width: 960px;
        height: 1300px;
        margin: 0 auto;
        background: url("../assets/img/高端律师服务内容.png") no-repeat;
        background-size: cover;
    }
    p{
        padding-top: 60px;
        padding-bottom: 30px;
        font-size: 22px;
        color: rgb(51,51,51);
        text-align: center;
    }
    .el-button{
        width:150px;
        height:50px;
        border-radius:8px;
        color:white;
        background:rgb(50,150,250);
        font-size:14px;
        font-weight:550;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/serviceP.vue